import { Caption } from '../textNodes'

const schoolRatingStudentsListEmpty = () => (
    <Caption className="schoolRatingStudentsListEmpty">
      { I18n.t('schoolRating.empty.listCaption') }
    </Caption>
)

export default schoolRatingStudentsListEmpty
